var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivingTributeOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 4H5.33333C4.59695 4 4 4.59695 4 5.33333V9.33333C4 10.0697 4.59695 10.6667 5.33333 10.6667H9.33333C10.0697 10.6667 10.6667 10.0697 10.6667 9.33333V5.33333C10.6667 4.59695 10.0697 4 9.33333 4Z",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 4H22.6663C21.93 4 21.333 4.59695 21.333 5.33333V9.33333C21.333 10.0697 21.93 10.6667 22.6663 10.6667H26.6663C27.4027 10.6667 27.9997 10.0697 27.9997 9.33333V5.33333C27.9997 4.59695 27.4027 4 26.6663 4Z",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 21.334H5.33333C4.59695 21.334 4 21.9309 4 22.6673V26.6673C4 27.4037 4.59695 28.0007 5.33333 28.0007H9.33333C10.0697 28.0007 10.6667 27.4037 10.6667 26.6673V22.6673C10.6667 21.9309 10.0697 21.334 9.33333 21.334Z",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 21.334H23.9997C23.2924 21.334 22.6142 21.6149 22.1141 22.115C21.614 22.6151 21.333 23.2934 21.333 24.0007V28.0007",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28V28.0133",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 9.33398V13.334C15.9997 14.0412 15.7187 14.7195 15.2186 15.2196C14.7185 15.7197 14.0403 16.0007 13.333 16.0007H9.33301",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16H4.01333",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4H16.0133",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.334V21.3473",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 16H22.6663",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16V16.0133",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16 27.9993V26.666",
    stroke: "#2F4E77",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivingTributeOne);
export default __webpack_public_path__ + "static/media/living-tribute-one.09f776dbd6500bb6a10f925b1def3e57.svg";
export { ForwardRef as ReactComponent };